import {
    FETCH_TRENDS_BEGIN,
    FETCH_TRENDS_SUCCESS,
    FETCH_TRENDS_FAILURE,
    CHANGE_TREND_VALUE,
    RESET_STATE
} from '../constants/trendsActionTypes';
import { getQueryStringValue } from '../utils';

const initialState = {
    isLoading: true,
    trendsDetails: '',
    selectedTrend: '',
    error: {},
    startPosition: '0'
}

export default function (state, action) {
    if (typeof state === 'undefined') {
        state = initialState;
    }
    switch (action.type) {
        case FETCH_TRENDS_BEGIN:
            return {
                ...state,
                isLoading: true
            };
        case FETCH_TRENDS_SUCCESS:
            return {
                ...state,
                trendsDetails: action.payload,
                selectedTrend: getQueryStringValue('trendId') ? action.payload.view.find(trend => Number(trend.id) === Number(getQueryStringValue('trendId')) ) :action.payload.view[0],
                isLoading: false,
            };
        case FETCH_TRENDS_FAILURE:
            return {
                ...state,
                error: action.payload,
                isLoading: false,
            };
        case CHANGE_TREND_VALUE:
            return {
                ...state,
                selectedTrend: action.payload
            }
        case RESET_STATE:
            return {
                ...initialState
            }
        default:
            return state;
    }
}
